import clsx from 'clsx';
import Image from 'next/image';
import { FC } from 'react';

import type { Header } from '@portal/types/studio/studio';
import { urlFor } from 'shared/utils/urlFor';
import styles from './Logo.module.scss';

interface HeaderLogoProps {
  header: Pick<Header, 'logo'>;
  logoSVG?: string;
  isWhite?: boolean;
}

const HeaderLogo: FC<HeaderLogoProps> = ({ header, logoSVG, isWhite }) => (
  <>
    {logoSVG?.length ? (
      <div
        className={clsx(styles.logo, isWhite && styles.white)}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: logoSVG }}
      />
    ) : (
      <>
        {isWhite ? (
          <Image
            src={header?.logo?.whiteIcon ? urlFor(header?.logo?.whiteIcon).url : ''}
            alt={header?.logo?.whiteIcon?.alt || ''}
            width={118}
            height={48}
            className={styles.logo}
            priority
          />
        ) : (
          <Image
            src={header?.logo?.icon ? urlFor(header.logo.icon).url : ''}
            alt={header?.logo?.icon?.alt || ''}
            width={118}
            height={48}
            className={styles.logo}
            priority
          />
        )}
      </>
    )}
  </>
);

export default HeaderLogo;
